import { sortCx } from "@/utils/cx";

/**
 * Text-link color styles aligned with Button `link-*` variants.
 * Use on react-router `Link`, anchors, or other inline text links
 * (Button wraps children in `data-text`, so its underline selectors differ).
 */
export const textLinkStyles = sortCx({
	destructive: [
		"text-error-primary outline-error hover:text-error-primary_hover",
		"underline decoration-transparent underline-offset-2 hover:decoration-current",
	].join(" "),
	gray: [
		"text-tertiary hover:text-tertiary_hover",
		"underline decoration-transparent underline-offset-2 hover:decoration-current",
	].join(" "),
	primary: [
		"text-brand-secondary hover:text-brand-secondary_hover",
		"underline decoration-transparent underline-offset-2 hover:decoration-current",
	].join(" "),
	white: [
		"hover:text-white_hover text-white",
		"underline decoration-transparent underline-offset-2 hover:decoration-current",
	].join(" "),
});
